// extracted by mini-css-extract-plugin
export default {"wrapper":"techniques_list__wrapper--fM0V","h1":"techniques_list__h1--IjHH","allStyles":"techniques_list__allStyles--Q5WE","allStylesLink":"techniques_list__allStylesLink--4fyf"};